// Utils
import { attachGeneratedObjectIdRecursivelyOrReturn } from './objectIdentity';
import { commit } from './changeDetection';
/**
 * @description recursively attach generated identifier and commits the given object, or returns the given object if there are no changes uncommitted and the object and nested objects all have identifiers attached
 *
 * @template T
 * @param {T} values
 *
 * @return {T}
 */
export var commitPendingChanges = function (values) {
    var result = attachGeneratedObjectIdRecursivelyOrReturn(values);
    result = commit(result);
    return result;
};
//# sourceMappingURL=commitPendingChanges.js.map